<nb-actions size="tiny" class="social-contacts">
  <nb-action class="custom-action">About Us</nb-action>
  <nb-action class="custom-action">Blog</nb-action>
  <nb-action class="custom-action">Follow Us</nb-action>
  <nb-action class="control-item" icon="facebook"></nb-action>
  <nb-action class="control-item" icon="twitter"></nb-action>
</nb-actions>

